import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ru from './locales/ru.json';
import en from './locales/en.json';
import pt from './locales/pt.json';

// Skeleton setup — most UI strings still live inline.
// Only the seed keys in locales/*.json are translated.
// Goal: unblock future migration without refactoring screens today.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en', 'pt'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'moms_lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
